import React, {useEffect, useRef, useState} from "react";
import ausPhone from "../../utils/aus-phone";
import { withStyles } from '@material-ui/core/styles';
import PhoneForwardedIcon from  "@material-ui/icons/PhoneForwarded";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import {useStore} from "../../store";
import {fetchAccount} from "../../store/actions";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import {CreditCardPanel, StripeCardForm} from "../../components";
import Typography from "@material-ui/core/Typography";
import {scroller} from "react-scroll";
import {ReactComponent as VisaLogo} from "../../images/visa-logo.svg";
import {ReactComponent as MasterCardLogo} from "../../images/mastercard-logo.svg";
import {PurchaseService} from "../../services";
import {CircularProgress} from "@material-ui/core";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const Accordion = withStyles({
    root: {
        // border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        // backgroundColor: 'rgba(0, 0, 0, .03)',
        // borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        padding: 0,
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        // backgroundColor: 'rgba(0, 0, 0, .03)',
        // padding: theme.spacing(2),
        padding: 0,
    },
}))(MuiAccordionDetails);

const Checkout = ({order, onSuccess, onError}) => {
    const [store, dispatch] = useStore();   // Get the global store

    // If we don't have an SKU then we can't proceed
    if (order.sku.id === '' || typeof(order.sku.id) === 'undefined') {
        onError({code:'invalid_sku_id', message:'SKU ID is required'})
    }

    // Scroll to the payment method section so the 'Buy' button is visible
    useEffect(() => {
        // const el = (location.state && location.state.scrollTo) || ''
        scroller.scrollTo('payment-method', {
            duration    : 800,
            delay       : 1200,
            smooth      : 'easeInOutQuart',
            containerId : 'psb',
        });
    },[])

    // Make sure the account is available in the store
    useEffect(()=> {
        if (store.user.accountId) {
            dispatch(fetchAccount(store.user.accountId, store, dispatch))
        }
    }, [store.user.accountId, store, dispatch])

    //console.log('order', order);

    return (
        <div>
            <div className="flex flex-row w-full content-center">
                <Typography variant="h6" color="secondary" className="flex-grow">Checkout</Typography>
                <ShoppingCartIcon color="secondary" className="mt-1"/>
            </div>

            <div className="flex flex-col flex-grow mb-4">
                { order.sku.type === 'number' ?
                    <LandlineItem order={order}/>
                    : null
                }
                { order.sku.type === 'credit' ?
                    <CreditItem order={order}/>
                    : null
                }
                { order.sku.type === 'service' ?
                    <ServiceItem order={order}/>
                    : null
                }

                <TotalSection order={order}/>

            </div>

            <PaymentSection order={order} store={store} onSuccess={onSuccess} onError={onError}/>

        </div>
    )
}


const LandlineItem = ({order}) => {
    return (
        <>
            <hr className="my-4"/>
            <div className="flex flex-col flex-grow my-4">
                <div className="flex flex-row">
                    <div className="text-5xl mr-5">
                        <PhoneForwardedIcon color="secondary" fontSize="inherit"/>
                    </div>
                    <div className="flex flex-col">
                        <div className="font-bold text-xl my-1">{order.sku.name}</div>
                        <div className="text-gray-600 mb-4">{order.sku.meta.description}</div>

                        <div className="grid gap-x-4 gap-y-1 grid-cols-2 xs:grid-cols-3">
                            <div className="text-gray-600 hidden xs:block">Number</div>
                            <div className="font-bold col-span-2">{ausPhone(order.number.number)}</div>
                            <hr className="col-span-3"/>
                            <div className="text-gray-600 hidden xs:block">Zone</div>
                            <div className="font-bold col-span-2">{order.number.zone}</div>
                            <hr className="col-span-3"/>
                            <div className="text-gray-600 hidden xs:block">Includes</div>
                            <div className="font-bold col-span-2">{order.sku.meta.inclusions.description}</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="my-4"/>
        </>
    )
}

const CreditItem = ({order}) => {
    return (
        <>
            <hr className="my-4"/>
            <div className="flex flex-col flex-grow my-4">
                <div className="flex flex-row">
                    <div className="text-5xl mr-5">
                        <TimerOutlinedIcon color="secondary" fontSize="inherit"/>
                    </div>
                    <div className="flex flex-col">
                        <div className="font-bold text-xl my-1">{order.sku.name}</div>
                        <div className="text-gray-600 mb-4">{order.sku.meta.description}</div>

                        <div className="grid gap-x-4 gap-y-1 grid-cols-2 xs:grid-cols-3">
                            <div className="text-gray-600 hidden xs:block">Minutes</div>
                            <div className="font-bold col-span-2">{order.sku.meta.inclusions.minutes.quantity}</div>
                            <hr className="col-span-3"/>
                            <div className="text-gray-600 hidden xs:block">Expiry</div>
                            <div className="font-bold col-span-2">{order.sku.meta.inclusions.minutes.expiryDays} days</div>
                            <hr className="col-span-3"/>
                            <div className="text-gray-600 hidden xs:block">Number</div>
                            <div className="font-bold col-span-2">{ausPhone(order.number.number)}</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="my-4"/>
        </>
    )
}

const ServiceItem = ({order}) => {
    return (
        <>
            <hr className="my-4"/>
            <div className="flex flex-col flex-grow my-4">
                <div className="flex flex-row">
                    <div className="text-5xl mr-5">
                        <ArrowForwardIcon color="secondary" fontSize="inherit"/>
                    </div>
                    <div className="flex flex-col">
                        <div className="font-bold text-xl my-1">{order.sku.name}</div>
                        <div className="text-gray-600 mb-4">{order.sku.meta.description}</div>

                        <div className="grid gap-x-4 gap-y-1 grid-cols-2">
                            <div className="text-gray-600">Number</div>
                            <div className="font-bold col-span-2">{ausPhone(order.number.number)}</div>
                            <hr className="col-span-3"/>
                            <div className="text-gray-600">Transfer To</div>
                            <div className="font-bold col-span-2">{ausPhone(order.transferTo)}</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="my-4"/>
        </>
    )
}


const TotalSection = ({order}) => {
    if (order.sku.taxRate === 0) {
        return (
            <div className="grid grid-cols-2 gap-y-2 mb-2">
                <div className="self-center">Total including taxes</div>
                <div className="text-right grid grid-cols-2">
                    <div className="text-xs text-gray-600 self-center mr-1">AUD</div>
                    <div className="text-2xl font-bold"> ${order.total.toFixed(2)}</div>
                </div>
            </div>
        )
    } else {
        return (
            <>
                <div className="grid grid-cols-2 gap-y-2 mb-2">
                    <div>Subtotal</div>
                    <div className="text-right">${order.subtotal.toFixed(2)}</div>
                    <div>Taxes ({order.sku.taxRate}%)</div>
                    <div className="text-right"> ${order.taxes.toFixed(2)}</div>
                </div>
                <hr/>
                <div className="grid grid-cols-2 gap-y-2 mt-4 mb-2">
                    <div className="self-center">Total</div>
                    <div className="text-right text-2xl">
                        <span className="text-xs text-gray-600">AUD</span>
                        <span className="font-bold"> ${order.total.toFixed(2)}</span>
                    </div>
                </div>
            </>
        )
    }
}

const PaymentSection = ({order, store, onSuccess, onError}) => {

    // Payment method accordion state
    const isStored = store.account.paymentMethod && store.account.paymentMethod.type === 'card';
    //console.log('isStored', isStored)

    const [expanded, setExpanded] = useState(isStored ? 'stored' : 'new')

    // handleAccordionChange ensures only one accordion is expanded at a time.
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : '');
    }
    //console.log('expanded', expanded);

    const [state, setState] = useState({cardError: null})
    //console.log('Payment Section state', state)


    //console.log('store.account', store.account);

    // Track our mounted state so we don't try and setState() after we're gone
    let isMounted = useRef(true)
    useEffect(() => {
        // React calls the return function when the component is unmounted
        return () => {isMounted.current = false}
    })

    // If we expand the 'new' accordion scroll the page so the Pay button is visible
    useEffect(() => {
        if (isStored && expanded === 'new') {
            scroller.scrollTo('payment-method', {
                duration    : 800,
                delay       : 200,
                smooth      : 'easeInOutQuart',
                containerId : 'psb',
            });
        }
    }, [isStored, expanded])

    const onSubmit = (data) => {
        //console.log('PaymentMethodSection onSubmit', data);

        if (typeof(data) === 'undefined') {
            data = {}
        }

        // Clear any previous card errors
        setState({...state, cardError: null, isFetching: true})

        return new Promise((resolve, reject) => {

            const request = {
                accountId: store.account.id,
                skuId:     order.sku.id,
                price:     order.total * 100,
                number:    order.number ? order.number.number || '' : '',
                serviceId: order.serviceId || 0,
                ticketId:  order.ticketId || 0,
                tokenId:   data.token ? data.token.id || '' : '',
                saveCard:  data.saveCard || false,
            }

            // Process the the purchase
            PurchaseService.purchase(request)
                .then(result => {
                    //console.log('checkout: purchase succeeded', result);

                    // Let our parent component know the checkout was successful
                    if (typeof(onSuccess) === 'function') {
                        onSuccess(result);
                    }
                    if (isMounted.current) {
                        setState({...state, isFetching: false});
                    }
                    resolve();  // Let the form know we're done.
                })
                .catch(error => {
                    //console.log('purchase failed', error);
                    if (error.status === 402) {
                        // It's a card error so set the local cardError state
                        // The error will be displayed in the CardForm component if
                        // we're using a new card, or locally if we're using a saved card.
                        setState({...state, cardError: error.data.error, isFetching: false})
                    } else {
                        // Treat it as an API error and pass it on up the chain
                        if (typeof(onError) === 'function') {
                            onError(error);
                        }
                    }
                    resolve();  // Let the form know we're done.
                })
        })
    }

    if (isStored) {
        return (
            <div id="payment-method">
                <Accordion
                    expanded={expanded === 'stored'}
                    onChange={handleAccordionChange('stored')}
                    className="w-full"
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <div><Radio value="existing" checked={expanded==='stored'}/>Pay with saved card</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="w-full mb-2">
                        <div className="bg-white border rounded-sm mb-4 w-full">
                            <CreditCardPanel paymentMethod={store.account.paymentMethod}/>
                        </div>
                        <div className="flex flex-row my-3">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => onSubmit()}
                                disabled={state.isFetching}
                                className="w-full"
                            >
                                { state.isFetching ?
                                    <CircularProgress size={24} />
                                    :
                                    `Pay $${order.total.toFixed(2)}`
                                }
                            </Button>
                        </div>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    expanded={expanded === 'new'}
                    onChange={handleAccordionChange('new')}
                    className="w-full"
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <div><Radio value="existing" checked={expanded==='new'}/>Pay with another card</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div id="new-card">
                            <StripeCardForm
                                onSubmit={onSubmit}
                                cardError={state.cardError}
                                options={{
                                    buttonTitle:`Pay $${order.total.toFixed(2)}`,
                                    storeCheckbox: true,
                                    dense: true,
                                }}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        )

    } else {
        return (
            <div id="payment-method" className="w-full">
                <div className="flex flex-row mb-1">
                    <Typography variant="subtitle1" color="secondary" className="flex-grow">Card Details</Typography>
                    <div className="flex flex-row gap-2 mt-1">
                        <VisaLogo height={15} width={30}/>
                        <MasterCardLogo height={15} width={25}/>
                    </div>
                </div>
                <StripeCardForm
                    onSubmit={onSubmit}
                    cardError={state.cardError}
                    options={{
                        buttonTitle:`Pay $${order.total.toFixed(2)}`,
                        storeCheckbox: true,
                        dense: true,
                    }}
                />
            </div>
        )
    }

}

export default Checkout;